import React from 'react'

const LoadingPanel = (props) => {
    const { isLoading } = props;
    return (
        <div role="alert" aria-live="assertive">
            {isLoading && <div>
                <div className="loading-cover"></div>
                <span className="loading-text">Loading</span>
                <div className="loading-animation">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>}
        </div>
    );
}
export default LoadingPanel;